import {Component, OnInit} from '@angular/core';
import {Platform} from '@angular/cdk/platform';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-hubapp',
  templateUrl: './hubapp.component.html',
  styleUrls: ['./hubapp.component.scss']
})
export class HubappComponent implements OnInit {
  productName = environment.programNameHub;
  androidStoreURL: string = environment.hubAndroidStore;
  iosStoreURL: string = environment.hubIosStore;
  referredCodeParam: string;

  namespace = environment.namespace;
  url = environment.homeEndpoint.slice(8);

  constructor(public platform: Platform, protected router: Router, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    const brokerCode: string = this.route.snapshot.queryParamMap.get('brokerCode');
    this.referredCodeParam = brokerCode;
    const externalReferenceCode: string = this.route.snapshot.queryParamMap.get('externalReferenceCode');
    let storeAndroidLink = '';
    let dataReferredCode: string = null;
    let dataExternalReferenceCode: string = null;

    if (brokerCode !== null && brokerCode !== '') {
      dataReferredCode = `brokerCode%3D${brokerCode}`;
    }

    if (externalReferenceCode !== null && externalReferenceCode !== '') {
      dataExternalReferenceCode = `externalReferenceCode%3D${externalReferenceCode}`;
    }

    if (brokerCode !== null || externalReferenceCode !== null) {
      storeAndroidLink = `&referrer=${dataReferredCode ?? ''}${dataReferredCode !== null && dataExternalReferenceCode != null ? '%26' : ''}${dataExternalReferenceCode ?? ''}`;
    }
    this.androidStoreURL = `${this.androidStoreURL}${storeAndroidLink}`;

    if (this.platform.IOS) {
      window.location.href = this.iosStoreURL;
    }
    if (this.platform.ANDROID) {
      window.location.href = this.androidStoreURL;
    }
  }

}
